// cookie key
export const IS_CAFE_COOKIE = "isCafe"; // PC방 접속 여부
export const NX_LATC_COOKIE = "NXLATC"; // 최근 로그인에 성공한 TPA Code
export const NX_TPA_COOKIE = "NXTPA"; // nxlogin 최근 로그인 수단
export const NX_SIGNUP_COOKIE = "NXSIGNUP"; // 간편 가입 (인증 없이 가입)
